export default {
    methods: {
        resolveAmount(amount) {
            return amount.toString().includes('.')
                ? amount.toString().split('.')[1].length > 2
                    ? amount.toString().substring(0, amount.toString().indexOf('.') + 3)
                    : amount.toString().split('.')[1].length === 1
                        ? amount.toString().concat('0')
                        : amount
                : amount.toString().concat('.00');
        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/makeCorrectAmount.js